<div class="alert alert-box fade show" [ngClass]="alertObject.type === 'ERROR'? 'alert-danger' : 'alert-success' " *ngIf="undefined != alertObject && undefined != alertObject.message">
    <button type="button" (click)="resetAlert()" class="close">&times;</button>
    <strong>{{alertObject.title}}</strong> {{alertObject.message | uppercaseFirstLetter}}
</div>
